export const validatorDependenteSemValorAdicional = valoresForm => {
    const arrayDeValidacoes = [
        verificarParentescoPermitido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarSemAdicional(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorSomenteEsposoSemExConjuge = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        !verificarPossuiDependenteTipoExConjuge(dependentes),
        verificarCategoriaSemValorAdicional(valoresForm.Categoria),
        verificarGrauParentescoConjuge(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria)

    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorSomenteMaeSemMadrasta = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        !verificarPossuiDependenteTipoMadrasta(dependentes),
        verificarCategoriaSemValorAdicional(valoresForm.Categoria),
        verificarGrauParentescoMae(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria)

    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorSomentePaiSemPadrasto = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        !verificarPossuiDependenteTipoPadrasto(dependentes),
        verificarCategoriaSemValorAdicional(valoresForm.Categoria),
        verificarGrauParentescoPai(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria)

    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorAte64Anos = valoresForm => {
    const arrayDeValidacoes = [
        !verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarParentescoNaoPermitido(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaiorIgual65Anos = valoresForm => {
    const arrayDeValidacoes = [
        !verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarParentescoNaoPermitido(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaior79Anos = valoresForm => {
    const arrayDeValidacoes = [
        !verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarParentescoNaoPermitido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAcima79(valoresForm.Categoria),
        idadeAcima79(valoresForm.Idade)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorConjugeMaior79Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarGrauParentescoConjuge(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAcima79(valoresForm.Categoria),
        idadeAcima79(valoresForm.Idade),
        (verificarPossuiDependenteTipoEsposo(dependentes) || verificarPossuiDependenteTipoExConjugeSemValorAdicional(dependentes))

    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaeMaior79Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAcima79(valoresForm.Idade),
        verificarGrauParentescoMae(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAcima79(valoresForm.Categoria),
        (verificarPossuiDependenteTipoMae(dependentes) || verificarPossuiDependenteTipoMadrastaSemValorAdicional(dependentes))
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPaiMaior79Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAcima79(valoresForm.Idade),
        verificarGrauParentescoPai(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAcima79(valoresForm.Categoria),
        (verificarPossuiDependenteTipoPai(dependentes) || verificarPossuiDependenteTipoPadrastoSemValorAdicional(dependentes))
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorConjugeAte64Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        verificarGrauParentescoConjuge(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria),
        (verificarPossuiDependenteTipoEsposo(dependentes) || verificarPossuiDependenteTipoExConjugeSemValorAdicional(dependentes))
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorConjugeMaiorIgual65Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        verificarGrauParentescoConjuge(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria),
        (verificarPossuiDependenteTipoEsposo(dependentes) || verificarPossuiDependenteTipoExConjugeSemValorAdicional(dependentes))
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaeAte64Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        verificarGrauParentescoMae(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria),
        (verificarPossuiDependenteTipoMae(dependentes) || verificarPossuiDependenteTipoMadrastaSemValorAdicional(dependentes))
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaeMaiorIgual65Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        verificarGrauParentescoMae(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria),
        (verificarPossuiDependenteTipoMae(dependentes) || verificarPossuiDependenteTipoMadrastaSemValorAdicional(dependentes))
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPaiAte64Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        verificarGrauParentescoPai(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria),
        (verificarPossuiDependenteTipoPai(dependentes) || verificarPossuiDependenteTipoPadrastoSemValorAdicional(dependentes))
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPaiMaiorIgual65Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        verificarGrauParentescoPai(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)

    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorExConjugeMaior79 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAcima79(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAcima79(valoresForm.Categoria),
        verificarGrauParentescoExConjuge(valoresForm.Parentesco),
        verificarPossuiDependenteTipoEsposo(dependentes) || verificarPossuiDependenteTipoExConjugeSemValorAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorExConjugeAte64 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarGrauParentescoExConjuge(valoresForm.Parentesco),
        verificarPossuiDependenteTipoEsposo(dependentes) || verificarPossuiDependenteTipoExConjugeSemValorAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorExConjugeMaiorIgual65 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarGrauParentescoExConjuge(valoresForm.Parentesco),
        verificarPossuiDependenteTipoEsposo(dependentes) || verificarPossuiDependenteTipoExConjugeSemValorAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMadrastaAte64 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarGrauParentescoMadrasta(valoresForm.Parentesco),
        verificarPossuiDependenteTipoMae(dependentes) || verificarPossuiDependenteTipoMadrastaSemValorAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMadrastaMaior79 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAcima79(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAcima79(valoresForm.Categoria),
        verificarGrauParentescoMadrasta(valoresForm.Parentesco),
        verificarPossuiDependenteTipoMae(dependentes) || verificarPossuiDependenteTipoMadrastaSemValorAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMadrastaMaiorIgual65 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarGrauParentescoMadrasta(valoresForm.Parentesco),
        verificarPossuiDependenteTipoMae(dependentes) || verificarPossuiDependenteTipoMadrastaSemValorAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPadrastoAte64 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarGrauParentescoPadrasto(valoresForm.Parentesco),
        verificarPossuiDependenteTipoPai(dependentes) || verificarPossuiDependenteTipoPadrastoSemValorAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPadrastoMaior79 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAcima79(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAcima79(valoresForm.Categoria),
        verificarGrauParentescoPadrasto(valoresForm.Parentesco),
        verificarPossuiDependenteTipoPai(dependentes) || verificarPossuiDependenteTipoPadrastoSemValorAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPadrastoMaiorIgual65 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarGrauParentescoPadrasto(valoresForm.Parentesco),
        verificarPossuiDependenteTipoPai(dependentes) || verificarPossuiDependenteTipoPadrastoSemValorAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDependentesQuePodemSemOuComAdicionalAte64 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarParentescosPodemSemOuComAdicional(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        !idadeAte64(valoresForm.Idade),
        !verificarAdicionalAte64(valoresForm.Categoria),
        !verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDependentesQuePodemSemOuComAdicionalMaior79 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarParentescosPodemSemOuComAdicional(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        !idadeAcima79(valoresForm.Idade),
        !verificarAdicionalAcima79(valoresForm.Categoria),
        !verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDependentesQuePodemSemOuComAdicionalMaiorIgual65 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarParentescosPodemSemOuComAdicional(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        !idadeAte65(valoresForm.Idade),
        !verificarAdicionalAte65(valoresForm.Categoria),
        !verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescosComRegrasEspeciaisAte64 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        !idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        !verificarAdicionalAte64(valoresForm.Categoria),
        !verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescoEmDuplicidadeCadastro = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm, true)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescoEmDuplicidadeEdicao = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm, false)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificaSeJaPossuiParentescoSelecionado = (dependentes, values, isCadastro) => {
    const seq = values.Seq;
    const parentesco = values.Parentesco;
    const parentescosQuePodemSerMaisQueUm = ['5', '50', '03', '07', '10006', '10016', '22', '12', '20', '19', '24', '32'];

    if (!parentesco) {
        return false;
    }

    if (parentescosQuePodemSerMaisQueUm.includes(parentesco.trim())) {
        return false;
    }

    const possuiParentescoSelecionado = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === parentesco.trim());

    if (!possuiParentescoSelecionado.length) {
        return false;
    }

    if (parentesco.trim() === '15' && isCadastro) {
        return possuiParentescoSelecionado.length === 2;
    }

    if (parentesco.trim() === 'AVô' && isCadastro) {
        return possuiParentescoSelecionado.length === 4;
    }

    if (parentesco.trim() === '15' && !isCadastro) {
        return seq !== possuiParentescoSelecionado[0].Seq &&
            seq !== possuiParentescoSelecionado[1].Seq;
    }

    if (parentesco.trim() === 'AVô' && !isCadastro) {
        return seq !== possuiParentescoSelecionado[0].Seq &&
            seq !== possuiParentescoSelecionado[1].Seq &&
            seq !== possuiParentescoSelecionado[2].Seq &&
            seq !== possuiParentescoSelecionado[3].Seq;
    }

    if (seq) {
        return seq !== possuiParentescoSelecionado[0].Seq;
    }

    return true;
};

const verificarPossuiDependenteDeGrauEquivalenteSemAdicional = (dependentes, seq, parentesco) => {
    const dependente = dependentes.find(dependente => {
        const dependenteGrauParentesco = dependente['GrauParentesco.Grau'].trim();
        const dependenteGrauEquivalente = grausEquivalentes[dependenteGrauParentesco];

        const dependenteCategoria = dependente['CategoriaParentesco.Categoria'];

        return (dependenteGrauParentesco === parentesco || dependenteGrauEquivalente === parentesco) && dependenteCategoria === 'ZELO' && dependente.Seq !== seq;
    });

    return dependente ? true : false;
};

export const parentescosComRegrasEspeciais = [
    '01',
    '02',
    '10',
    '32',
    '20008',
    '20007'
];

export const parentescosPermitidos = [
    '10006',
    '15',
    '5',
    '50'
];

export const grausEquivalentes = {
    '01': '20008',
    '20008': '01',

    '02': '20007',
    '20007': '02',

    '10': '32',
    '32': '10'
};

export const parentescosPodemSemOuComAdicional = [
    '20008',
    '20007',
    '32'
];

const verificarParentescoPermitido = parentesco => {
    const parentescoEncontrado = parentescosPermitidos.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado !== undefined ? true : false;
};

const verificarParentescoNaoPermitido = parentesco => {
    const parentescoEncontrado = parentescosPermitidos.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado !== undefined ? false : true;
};

const verificarParentescosComRegrasEspeciais = parentesco => {
    const parentescoEncontrado = parentescosComRegrasEspeciais.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado ? true : false;
};

const verificarPossuiDependenteTipoEsposo = dependentes => {
    const dependenteTipoEsposo = dependentes.find(dependente => dependente.Parentesco === 'ESPOSO(A)');

    return dependenteTipoEsposo ? true : false;
};

const verificarPossuiDependenteTipoExConjuge = dependentes => {
    const dependentetipoExConjuge = dependentes.find(dependente => dependente.Parentesco === 'EX-CONJUGE');

    return dependentetipoExConjuge;
};

const verificarPossuiDependenteTipoMae = dependentes => {
    const dependenteTipoMae = dependentes.find(dependente => dependente.Parentesco === 'MAE');

    return dependenteTipoMae ? true : false;
};

const verificarPossuiDependenteTipoPadrasto = dependentes => {
    const dependenteTipoPadrasto = dependentes.find(dependente => dependente.Parentesco === 'PADRASTO');

    return dependenteTipoPadrasto ? true : false;
};

const verificarPossuiDependenteTipoMadrasta = dependentes => {
    const depedenteTipoMadrasta = dependentes.find(dependente => dependente.Parentesco === 'MADRASTA');

    return depedenteTipoMadrasta ? true : false;
};

const verificarPossuiDependenteTipoPai = dependentes => {
    const depedenteTipoPai = dependentes.find(dependente => dependente.Parentesco === 'PAI');

    return depedenteTipoPai ? true : false;
};

const verificarPossuiDependenteTipoExConjugeSemValorAdicional = dependentes => {
    const dependentetipoExConjugeSemValorAdcional = dependentes.find(dependente => dependente.Parentesco === 'EX-CONJUGE' && dependente['CategoriaParentesco.Categoria'] === 'ZELO');

    return dependentetipoExConjugeSemValorAdcional ? true : false;
};

const verificarPossuiDependenteTipoMadrastaSemValorAdicional = dependentes => {
    const dependentetipoExMadrastaSemValorAdcional = dependentes.find(dependente => dependente.Parentesco === 'MADRASTA' && dependente['CategoriaParentesco.Categoria'] === 'ZELO');

    return dependentetipoExMadrastaSemValorAdcional ? true : false;
};

const verificarPossuiDependenteTipoPadrastoSemValorAdicional = dependentes => {
    const dependentetipoExPadrastoSemValorAdcional = dependentes.find(dependente => dependente.Parentesco === 'PADRASTO' && dependente['CategoriaParentesco.Categoria'] === 'ZELO');

    return dependentetipoExPadrastoSemValorAdcional ? true : false;
};

const verificarParentescosPodemSemOuComAdicional = parentesco => {
    const parentescoEncontrado = parentescosPodemSemOuComAdicional.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado ? true : false;
};

const verificarGrauParentescoConjuge = parentesco => parentesco === '10';
const verificarGrauParentescoMae = parentesco => parentesco === '02';
const verificarGrauParentescoPai = parentesco => parentesco === '01';
const verificarGrauParentescoExConjuge = parentesco => parentesco === '32';
const verificarGrauParentescoMadrasta = parentesco => parentesco === '20007';
const verificarGrauParentescoPadrasto = parentesco => parentesco === '20008';
const verificarCategoriaSemValorAdicional = categoria => categoria !== 'ZELO';
const verificarIdadePreenchida = idade => idade !== '' && idade !== null;
const verificarCategoriaPrenchida = categoria => categoria !== '';
const verificarParentescoPrenchido = parentesco => parentesco !== '';
const verificarSemAdicional = categoria => categoria.trim() !== 'ZELO';
const verificarAdicionalAte64 = categoria => categoria.trim() !== 'ZTA64';
const verificarAdicionalAte65 = categoria => categoria.trim() !== 'ZTA65' && categoria.trim() !== 'ZTM65';
const verificarAdicionalAcima79 = categoria => categoria.trim() !== 'ZTA79';
const idadeAte64 = idade => idade <= 64;
const idadeAte65 = idade => idade > 65; //&& idade <= 79;
const idadeAcima79 = idade => idade > 79;
const parentescos = {
    '01': 'PAI',
    '20008': 'PADRASTO',
    '02': 'MAE',
    '20007': 'MADRASTA',
    '10': 'ESPOSO(A)',
    '32': 'EX-CONJUGE',
    '15': 'SOGRO(A)',
    '5': 'FILHO(A)',
    '50': 'FILHO(A) ADOTIVO',
    '03': 'IRMA(O)',
    '07': 'SOBRINHO(A)',
    '10006': 'ENTEADO(A)',
    '10016': 'OUTROS',
    '12': 'NETO(A)',
    '22': 'PRIMO(A)',
    '19': 'GENRO',
    '20': 'NORA',
    '24': 'TIO(A)',
    'AVô': 'AVO',
    'PET': 'PET (ANIMAL)'
};

export const retornaLabelDoValorParentesco = valueParentesco => {
    const parentesco = valueParentesco.trim();

    if (parentesco === '15') {
        return `Só é permitido dois dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    if (parentesco === 'AVô') {
        return `Só é permitido quatro dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    if (parentesco === 'PET') {
        return '';
    }

    return `Só é permitido um dependente do tipo  ${parentescos[`${parentesco}`]}`;
};
